export const DialogStyle = {
  btn: {
    pluseIcon: {
      paddingRight: '5px',
      fontSize: '28px',
    },
    size: 'medium',
    variant: 'contained',
    sx: {
      backgroundColor: 'secondary.main',
    },
  },
  errorMessage: {
    style: {
      display: 'flex',
      flex: '1',
      alignItems: 'flex-start',
      marginTop: '16px',
    },
    sx: {
      color: 'text.secondary',
    },
  },
  brokenImage: {
    width: '15px',
    marginRight: '14px',
  },
  box: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
} as const;
